import { Paper } from '@mui/material';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import styled from 'styled-components';

export default styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 40px;
  margin-top: 46px;
`;

export const TextAreaCustom = styled(TextareaAutosize)`
  height: 100px;
  width: 100%;
`;

export const StyledPaper = styled(Paper)`
  padding: 25px;
  margin-bottom: 25px;

  .m10-0 {
    margin: 10px 0;
  }
`;
